import React, { Component, Fragment } from 'react';
import { Form, List, Checkbox, Carousel } from 'antd';
import _ from 'lodash';
import ReactPlayer from 'react-player/youtube';
import { __ } from '@wordpress/i18n';

import './styles.module.scss';
import styles from './styles.module.scss';
import NavTab from 'components/NavTab/NavTab';
import AppHelper from 'libs/AppHelper';
import whttp from 'libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import { API_HOST } from '../../configs/env';

const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
const Locale = _.get(window, 'VC_CONFIG.Locale');

const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 'all', //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
};

const CatalogMode = {
  Default: 1, // 預設列表
  Slider: 2, // 首頁橫向滑動
};

// 前端頁面
export default class CatalogueList extends Component {
  hasVideo = false;
  mouseInfo = { clientX: null, clientY: null };

  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    selectedCategoryId: null,
    isModalVisible: false,
    videoList: [],
  };

  componentDidMount() {
    const isFromThemePage = window.location.hash.includes('theme');
    const isFromWellcomePage = window.location.hash.includes('wellcome');
    const isFromLeafletPage = window.location.hash.includes('leaflet');
    const isFromMarketPage = window.location.hash.includes('market');
    const isFromNewOpeningPage = window.location.hash.includes('new-opening');
    this.loadData();
    this.lodavideoList();
    AppHelper.updateConfig((resp) => {
      // 選第一頁
      const options = _.get(this, 'props.app.options', {});
      const category_ids = _.get(this.props, 'category_ids', []);
      const catalogue_categories = _.filter(
        _.get(options, 'catalogue_categories', []),
        (category) => category_ids.indexOf(category.id) !== -1
      );

      this.setState({
        selectedCategoryId: isFromThemePage // 主題企劃
          ? 35
          : isFromWellcomePage // 頂好促銷
          ? 36
          : isFromLeafletPage // 報紙廣告
          ? 37
          : isFromMarketPage // 超市促銷
          ? 38
          : isFromNewOpeningPage // 新店開幕
          ? 39
          : _.get(catalogue_categories, '0.id'),
      });
    });
  }

  lodavideoList = (opt = { page: 1, page_size: '5' }) => {
    const { page, page_size } = opt;
    whttp.get(
      `${API_HOST}/api/v1/news?`,
      {
        page: page,
        page_size: page_size,
        'category_ids[]': 122,
      },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;
        const videoList = data.rows.map((item) => {
          return {
            videoURL: item.youtube,
            imageURL: item.images_previews.length ? item.images_previews[0].url || item.images[0].url : null
          };
        });
        const hasVideo = videoList.length > 0;
        this.setState({ videoList: videoList });
        this.hasVideo = hasVideo;
      }
    );
  };

  loadData = (opt = { page: 1, page_size: 'all' }) => {
    const { page, page_size } = opt;
    whttp.get(
      `${API_HOST}/api/v1/catalogues`,
      {
        page: page,
        page_size: page_size,
      },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        this.setState({ listInfo: data }, () => {
          this.reloadSwiper();
        });
      }
    );
  };

  reloadSwiper = () => {
    const Swiper = window.Swiper;

    if (!Swiper) return;
    window.swiperCatalog = new Swiper('.catalog-swiper', {
      slidesPerView: this.hasVideo ? 3 : 5,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: '.catalog-swiper-button-next',
        prevEl: '.catalog-swiper-button-prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          centeredSlides: true,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 0,
          centeredSlides: true,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
        },
      },
    });
  };

  handleClosePlayerModal = () => {
    this.setState({
      isModalVisible: false,
    });
  };

  handleMouseDownCarousel = (e) => {
    e.persist();
    this.mouseInfo = {
      clientX: e.clientX,
      clientY: e.clientY,
    };
  };

  handleMouseUpCarousel = (e, videoURL) => {
    e.persist();
    const { clientX, clientY } = this.mouseInfo;
    const isDragX = Math.abs(clientX - e.clientX) > 10;
    const isDragY = Math.abs(clientY - e.clientY) > 10;

    if (isDragX || isDragY) {
      return;
    }
    this.setState({
      isModalVisible: true,
      videoURL: videoURL,
    });
  };

  render() {
    const catalogues = _.get(this, 'state.listInfo.rows', []);
    // const catalogues = Array(5).fill({
    //   ...this.state.listInfo.rows[0],
    // });
    const options = _.get(this, 'props.app.options', {});
    const category_ids = _.get(this.props, 'category_ids', []);
    const catalogue_categories = _.filter(
      _.get(options, 'catalogue_categories', []).sort((a, b) => a.id - b.id),
      (category) => category_ids.indexOf(category.id) !== -1
    );
    const selectedCategoryId = _.get(
      this,
      'state.selectedCategoryId',
      _.get(catalogue_categories, '0.id')
    );
    const mode = this.props.mode || CatalogMode.Default;
    const urlQuery = AppHelper.getURLQuery();
    const isKiosk = urlQuery.view;
    const Locale = _.get(window, 'VC_CONFIG.Locale');
    const NavTavCate = [];

    if (Locale === 'en_US') {
      catalogue_categories.forEach((category) => {
        catalogues.find(
          (item) =>
            item.category_id == category.id &&
            item.category_id != 40 &&
            item.category_id != 41
        ) &&
          NavTavCate.push({
            id: category.id,
            name: category.name_en ? category.name_en : category.name,
          });
      });
    } else {
      catalogue_categories.forEach((category) => {
        catalogues.find(
          (item) =>
            item.category_id == category.id &&
            item.category_id != 40 &&
            item.category_id != 41
        ) &&
          NavTavCate.push({
            id: category.id,
            name: category.name,
          }); //category
      });
    }

    if (mode === CatalogMode.Default) {
      return (
        <main class='bg-light'>
          {NavTavCate.length > 0 && (
            <NavTab
              value={selectedCategoryId}
              tabs={_.map(NavTavCate, (category) => ({
                value: category.id,
                name: category.name,
              }))}
              onChange={(value, tabInfo) => {
                window.location.hash = '';
                this.setState({
                  selectedCategoryId: value,
                });
              }}
            />
          )}
          <div class='tab-content' id='pills-tabContent'>
            <div class='container'>
              <div class='row'>
                {catalogues
                  .filter(
                    (catalogues) =>
                      catalogues.category_id === this.state.selectedCategoryId
                  )
                  .map((catalogue) => {
                    const catalogueName = catalogue.en_name
                      ? catalogue.en_name
                      : catalogue.name;
                    var imgURL = _.split(_.first(catalogue.images), ' ').join(
                      encodeURIComponent(' ')
                    );
                    if (imgURL) {
                      imgURL = imgURL.replace('(', '%28');
                      imgURL = imgURL.replace(')', '%29');
                    }
                    return (
                      <div
                        class='col-6 col-md-4 column-lg-5 mb-4 wow fadeInUp'
                        data-wow-delay='0.1s'
                      >
                        <a
                          class='catalog-item mb-3'
                          role='button'
                          href={
                            Locale == 'en_US'
                              ? `${INDEX_URL}/catalogue-view-en?catalogue=${catalogueName}${
                                  isKiosk ? `&view=kiosk` : ''
                                }`
                              : `${INDEX_URL}/catalogue-view?catalogue=${catalogueName}${
                                  isKiosk ? `&view=kiosk` : ''
                                }`
                          }
                        >
                          <span
                            class='cover img-catalog mb-2'
                            style={{
                              backgroundImage: `url(${_.split(
                                catalogue.cover_url,
                                ' '
                              )
                                .join(encodeURIComponent(' '))
                                .replace('(', '%28')
                                .replace(')', '%29')})`,
                            }}
                          >
                            <span class='more'>
                              <i class='fas fa-eye' />
                            </span>
                          </span>
                          <h6 class='note align-self-start text-navy fw-700 mb-1'>
                            {(Locale == 'zh_TW' ||
                              (Locale == 'en_US' && !catalogue.en_name)) &&
                              catalogue.name}
                            {Locale == 'en_US' && catalogue.en_name}
                          </h6>
                          <div class='d-flex flex-lg-row flex-column justify-content-between aling-items-center w-100'>
                            <p class='note mb-lg-0 mb-2 text-dark'>
                              {catalogue.promotion_start_date}-
                              {catalogue.promotion_end_date}
                            </p>
                          </div>
                        </a>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </main>
      );
    }

    if (mode === CatalogMode.Slider) {
      return (
        <article class='catalog-section'>
          <div class='container'>
            <div class='row fadeInUp'>
              {this.hasVideo && (
                <div class='col-md-12 col-lg-5 order-lg-0 order-1'>
                  <div class='card card-primary border-0'>
                    <div class='card-header d-flex justify-content-between align-items-center'>
                      <strong class='h6 mb-0'>
                        {__('活動影片', 'cec-plugin-stores')}
                      </strong>
                    </div>
                    <div className='card-body p-3 carousel-wrapper'>
                      <Carousel
                        className='video'
                        swipeToSlide
                        draggable
                        autoplay
                        autoplaySpeed={5000}
                      >
                        {this.state.videoList.map((video) => {
                          return (
                            <div className='carousel-video'>
                              <div
                                className={styles['carousel-image']}
                                style={{
                                  backgroundImage: `url(${video.imageURL})`,
                                }}
                                onMouseDown={this.handleMouseDownCarousel}
                                onMouseUp={(e) =>
                                  this.handleMouseUpCarousel(e, video.videoURL)
                                }
                              >
                                <div className={styles['play-btn']}>
                                  <img
                                    src={`${
                                      window.VC_CONFIG.PLUGIN_ASSETS_URL
                                    }img/youtube-icon-dark.png`}
                                    width={64}
                                    height={45}
                                    alt=''
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Carousel>
                      {this.state.isModalVisible && (
                        <div
                          className={styles['mask-wrapper']}
                          onClick={this.handleClosePlayerModal}
                        >
                          <div className={styles['close-btn']}>
                            <img
                              src={`${
                                window.VC_CONFIG.PLUGIN_ASSETS_URL
                              }img/close-btn.svg`}
                              width={40}
                              height={40}
                              alt=''
                            />
                          </div>
                          <div className={styles['mask-content-wrapper']}>
                            <ReactPlayer
                              width={
                                window.innerWidth >= 1200 ? '1024px' : '100%'
                              }
                              height='576px'
                              url={this.state.videoURL}
                              playing
                              controls
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div
                class={`${
                  this.hasVideo
                    ? 'col-md-12 col-lg-7 order-lg-1 order-0  mb-lg-0 mb-5'
                    : 'col-lg-12'
                }`}
              >
                <div
                  class='card card-primary border-0'
                  style={{ height: '100%' }}
                >
                  <div class='card-header d-flex justify-content-between align-items-center'>
                    <strong class='h6 mb-0'>
                      {__('促銷目錄', 'cec-plugin-stores')}
                    </strong>
                    <a
                      class='h6 text-white mb-0'
                      role='button'
                      href={`${INDEX_URL}/catalogues${
                        Locale == 'en_US' ? '-en' : ''
                      }`}
                      data-toggle='tooltip'
                      data-placement='right'
                      title='看更多'
                    >
                      <i class='icon-plus' />
                    </a>
                  </div>
                  <div class='card-body p-3' style={{}}>
                    <div
                      class='catalog-swiper-wrap'
                      style={{
                        padding: '0 6rem',
                      }}
                    >
                      <div class='swiper-container catalog-swiper'>
                        <div class='swiper-wrapper'>
                          {catalogues
                            .filter(
                              (catalogue) =>
                                category_ids.indexOf(catalogue.category_id) !==
                                  -1 && catalogue.cover_url !== null
                            )
                            .map((catalogue, idx) => {
                              const catalogueName = catalogue.en_name
                                ? catalogue.en_name
                                : catalogue.name;
                              return (
                                <div class='swiper-slide'>
                                  <a
                                    class='catalog-item'
                                    role='button'
                                    href={`${INDEX_URL}/catalogue-view${
                                      Locale == 'en_US' ? '-en' : ''
                                    }?catalogue=${catalogueName}${
                                      isKiosk ? `&view=kiosk` : ''
                                    }`}
                                  >
                                    <span
                                      class='cover img-catalog'
                                      style={{
                                        backgroundImage: `url(${_.split(
                                          catalogue.cover_url,
                                          ' '
                                        )
                                          .join(encodeURIComponent(' '))
                                          .replace('(', '%28')
                                          .replace(')', '%29')})`,
                                      }}
                                    >
                                      <span class='more'>
                                        <i class='fas fa-eye' />
                                      </span>
                                    </span>
                                    <strong>
                                      {Locale == 'en_US' && catalogue.en_name
                                        ? catalogue.en_name
                                        : catalogue.name}
                                    </strong>
                                  </a>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <div class='control'>
                        <div class='catalog-swiper-button catalog-swiper-button-prev'>
                          <i class='icon-chevron-left' />
                        </div>
                        <div class='catalog-swiper-button catalog-swiper-button-next'>
                          <i class='icon-chevron-right' />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      );
    }

    return <Fragment />;
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };
export class CatalogueListEditor extends Component {
  formRef = React.createRef();
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  };
  componentDidMount() {
    AppHelper.updateConfig();
    this.formRef.current.setFieldsValue(this.props.attributes);
  }
  render() {
    const listInfo = this.state.listInfo;
    const options = _.get(this, 'props.app.options', {});

    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div alt='f538' class='dashicons dashicons-layout' />
          </span>
          促銷目錄列表
        </div>
        <Form
          ref={this.formRef}
          name='basic'
          className='basicForm'
          // layout="vertical"
          // onFinish={values => this.submitData(values)}
          onValuesChange={(changedFields, allFields) =>
            this.props.setAttributes(changedFields)
          }
        >
          <Form.Item {...genFormItemAtrribute('category_ids', '目錄類別')}>
            <Checkbox.Group>
              <List
                grid={listGrid}
                dataSource={_.get(options, 'catalogue_categories', [])}
                renderItem={(item) => (
                  <List.Item>
                    <Checkbox value={item.id}>{item.name}</Checkbox>
                  </List.Item>
                )}
              />
            </Checkbox.Group>
          </Form.Item>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/catalogues/catalogue-list.js